var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._v(
      "\n  " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm.presentAddress,
            "--",
            "",
            "",
            false
          )
        ) +
        "\n  " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm._f("parseAge")(_vm.member.birthdate),
            "--",
            "",
            "歳",
            false
          )
        ) +
        "\n  " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm.getNameOrUndefined(_vm.member, "gender.name"),
            "--",
            "",
            "",
            false
          )
        ) +
        "\n  / " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm._f("convertEmployedLabel")(_vm.member.employed),
            "--",
            "",
            "",
            false
          )
        ) +
        "\n  / " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm.annualSalary,
            "--",
            "年収",
            "万円",
            false
          )
        ) +
        "\n  / " +
        _vm._s(
          _vm._f("parseBlankForDefaultValue")(
            _vm._f("convertchangeOverJobsCountLabel")(
              _vm.member.changeOverJobsCount
            ),
            "--",
            "転職",
            "",
            false
          )
        ) +
        "\n"
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }